import { useRouter } from "next/router";
import React from "react";
import { useIntl } from "react-intl";

import FormattedMessage from "@components/UI/FormattedMessage";
import SimpleSelect from "@components/UI/SimpleSelect";

import { ROUTES } from "@shared/constants";

interface FilterBoxHotelNameProps {
  query: any;
  hotelNameOptions: { label: string; value: string }[];
}

const FilterBoxHotelName: React.FC<FilterBoxHotelNameProps> = ({
  query,
  hotelNameOptions,
}) => {
  const router = useRouter();
  const intl = useIntl();
  const selectedHotelName = Array.isArray(query.hotelName)
    ? query.hotelName[0]
    : query.hotelName;
  const selectedHotelNameOption =
    typeof selectedHotelName === "string" && selectedHotelName
      ? { label: selectedHotelName, value: selectedHotelName }
      : undefined;
  const options =
    selectedHotelNameOption &&
    !hotelNameOptions.some((option) => option.value === selectedHotelName)
      ? [selectedHotelNameOption, ...hotelNameOptions]
      : hotelNameOptions;

  const changeHotelNameFilter = (selectedOption: { value: string } | null) => {
    const newQuery = { ...query };
    if (selectedOption) {
      newQuery.hotelName = selectedOption.value;
    } else {
      delete newQuery.hotelName;
    }

    router.push(
      {
        pathname: ROUTES.HOTELS,
        query: newQuery,
      },
      undefined,
      { scroll: false }
    );
  };

  return (
    <div className="filters-box" id="filter-hotel-name">
      <span className="filters-label">
        <FormattedMessage id="Hotels.filters.hotelName" />:
      </span>
      <SimpleSelect
        options={options}
        value={options.find((option) => option.value === selectedHotelName)}
        placeholder={intl.formatMessage({
          id: "Hotels.filters.typeHotelName",
        })}
        onChange={changeHotelNameFilter}
        className="filter-hotel-name-select"
        isClearable
        testId="filter-hotel-name-select"
      />
    </div>
  );
};

export default FilterBoxHotelName;
